module.exports = __webpack_public_path__ + "img/lkk.3ceff927.svg";